(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2510],{

/***/ 50123:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/error",
      function () {
        return __webpack_require__(83023);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25923);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22470);
/* harmony import */ var components_landing_pages_v2_shared_Container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93524);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_LandingPageV2Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39275);







var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_1__.withRouter)(function(context) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_shared_LandingPageV2Layout__WEBPACK_IMPORTED_MODULE_2__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, context), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(RenderErrorPage, {})
    }));
}));
var RenderErrorPage = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(components_landing_pages_v2_shared_Container__WEBPACK_IMPORTED_MODULE_0__/* .LandingPageSectionContainer */ .IX, {
        $largerThanSM: {
            width: "40%"
        },
        marginTop: "$24x",
        justifyContent: "space-between",
        marginBottom: "15%",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                    paddingBottom: "$16x",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                            tag: "h2",
                            typography: "$subheaderLarge",
                            paddingBottom: "$4x",
                            children: "Something went wrong"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                            tag: "h2",
                            typography: "$bodyMedium",
                            children: "It looks like we ran into an issue while learning about your home. Try again, or start over by returning to the homepage."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                    paddingBottom: "$20x",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                            onPress: function(e) {
                                e.stopPropagation();
                                document.location.href = document.referrer;
                            },
                            analyticsName: "cosmos-error-try-again-button",
                            variant: "primary",
                            size: "small",
                            label: "Try again",
                            marginBottom: "$4x"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                            onPress: function(e) {
                                e.stopPropagation();
                                document.location.href = "https://www.opendoor.com";
                            },
                            analyticsName: "cosmos-error-return-to-homepage-button",
                            variant: "secondary",
                            size: "small",
                            label: "Return to homepage"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "$2x",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                            tag: "span",
                            typography: "$bodySmall",
                            children: "Contact us at"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
                            "aria-label": "opendoor-error-contact-email",
                            href: "mailto:support@opendoor.com",
                            size: "small",
                            analyticsName: "cosmos-error-page-contact-support",
                            color: "$contentPrimary",
                            variant: "primary",
                            children: "support@opendoor.com"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                            tag: "span",
                            typography: "$bodySmall",
                            children: "or"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
                            "aria-label": "opendoor-error-contact-email",
                            href: "tel:888-352-7075",
                            size: "small",
                            analyticsName: "cosmos-error-page-contact-support",
                            color: "$contentPrimary",
                            variant: "primary",
                            children: "888-352-7075"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                            tag: "span",
                            typography: "$bodySmall",
                            children: "if this happens again."
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 71390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var railsEnv_1 = __webpack_require__(27825);
var faviconPath = function (_a) {
    var _b = _a === void 0 ? {} : _a, admin = _b.admin, railsEnv = _b.railsEnv;
    var env = railsEnv || (0, railsEnv_1.getRailsEnv)();
    // these favicons created in this Figma document
    // https://www.figma.com/file/R2a9eL6fEQMq24CY2Q8752NB/Favicons?node-id=19%3A29
    if (admin) {
        if (env === 'development') {
            return 'https://images.opendoor.com/source/s3/imgdrop-production/1bd03e41b990465e93d1c5b90ba36c16.png?service=shared-fe&preset=square-48';
        }
        else if (env === 'staging') {
            return 'https://images.opendoor.com/source/s3/imgdrop-production/a8dddd737aeb4780bf9e8edfa8bdc27b.png?service=shared-fe&preset=square-48';
        }
        else if (env === 'qa') {
            return 'https://images.opendoor.com/source/s3/imgdrop-production/28c43a220c9247f1ba3764c6aa7f67b3.png?service=shared-fe&preset=square-48';
        }
        return 'https://images.opendoor.com/source/s3/imgdrop-production/6f05fac182304e3d821592580acf3a68.png?service=shared-fe&preset=square-48';
    }
    if (env === 'development') {
        return 'https://images.opendoor.com/source/s3/imgdrop-production/4ec068f491b4478293d83b56911a2f65.png?service=shared-fe&preset=square-48';
    }
    else if (env === 'staging') {
        return 'https://images.opendoor.com/source/s3/imgdrop-production/006a1ec0195a4e95bea9bd906d99130c.png?service=shared-fe&preset=square-48';
    }
    else if (env === 'qa') {
        return 'https://images.opendoor.com/source/s3/imgdrop-production/5618f1f758be4937861351a1c96548d6.png?service=shared-fe&preset=square-48';
    }
    return 'https://images.opendoor.com/source/s3/imgdrop-production/cf88fd37a91e43b0b7aafe6b076d2810.png?service=shared-fe&preset=square-48';
};
exports.Z = faviconPath;


/***/ }),

/***/ 27825:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRailsEnv = void 0;
exports.isRailsEnv = isRailsEnv;
exports.assertRailEnvOrThrow = assertRailEnvOrThrow;
var envs = ['production', 'staging', 'qa', 'development', 'test'];
function isRailsEnv(env) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return envs.includes(env);
}
function assertRailEnvOrThrow(env) {
    if (isRailsEnv(env)) {
        return env;
    }
    throw new Error("".concat(env, " is not a valid RailsEnv"));
}
var getRailsEnv = function () {
    var _a, _b, _c, _d;
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return 'development';
    }
    var hostname = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
    if (hostname === undefined) {
        return 'development';
    }
    var port = (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.port;
    var locationHasPort = port && port !== '';
    var onLocalhost = hostname === 'localhost';
    var onNgrok = hostname.includes('.ngrok.io');
    var onXipIO = hostname.includes('.xip.io');
    var inAndroidEmulator = hostname.includes('10.0.2.2');
    var inDevelopment = (onLocalhost && locationHasPort) || onNgrok || onXipIO || inAndroidEmulator;
    if (inDevelopment) {
        return 'development';
    }
    // In Rails CI, tests my be on a random port
    var inRailsCI = hostname === '127.0.0.1';
    // on localhost without a port corresponds to test environment
    if (inRailsCI || onLocalhost) {
        return 'test';
    }
    var onStagingManagedDomain = hostname.includes('-staging.managed.services.opendoor.com') ||
        hostname.includes('-staging.ops.opendoor.com') ||
        hostname.includes('-staging.opendoor.com');
    var onSimplersell = hostname.includes('.simplersell.com');
    var onODMortgage = hostname.includes('.odmortgage.com');
    var inStaging = onStagingManagedDomain || onSimplersell || onODMortgage;
    var inProduction = hostname.includes('.opendoor.com') && !hostname.includes('-staging');
    var inProdOrStaging = inStaging || inProduction;
    var onQADomain = hostname.includes('-qa-');
    var hasQACookie = ((_c = document === null || document === void 0 ? void 0 : document.cookie) === null || _c === void 0 ? void 0 : _c.includes('qa=')) && ((_d = document === null || document === void 0 ? void 0 : document.cookie) === null || _d === void 0 ? void 0 : _d.includes('qa_env='));
    // most QA usage will be on a staging domain (.e.g `demo.simplersell.com`) with appropriate
    // cookies set
    var inQA = onQADomain || (inProdOrStaging && hasQACookie);
    if (inQA) {
        return 'qa';
    }
    else if (inStaging) {
        return 'staging';
    }
    else if (inProduction) {
        return 'production';
    }
    // default case
    return 'development';
};
exports.getRailsEnv = getRailsEnv;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6852,7081,5527,6523,4490,2864,2345,5263,6356,4632,3665,9757,3178,8111,6077,5675,3589,5584,216,6885,9275,9774,2888,179], function() { return __webpack_exec__(50123); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);